<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>상담원 목록</p>

                <div class="area_button">
                    <button type="button" @click="add" class="active">상담원 등록</button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_head">
                            <div class="select-wrap">
                                <select name="orderType" v-model="state.order" @change="fnGetList(1)">
                                    <option value="0">최근순</option>
                                    <option value="1">과거순</option>
                                </select>
                            </div>

                            <div class="total_length">
                                {{ $t("notice.total") }} : {{ CommonUtils.numberFormat(pageState.length) }} {{ $t("notice.count") }}
                            </div>
                        </div>
                        <div class="area_table_body">
                            <DataGrid
                                :list="pageState.list"
                                :columns="pageState.fields"
                                :totalLength="pageState.length"
                                :perPage="pageState.perPage"
                                :cntPage="pageState.cntPage"
                                :current-page="pageState.currentPage"
                                :isLoading="pageState.isLoading"
                                @onRowClick="fnRowClick"
                                @onPaging="fnGetList"
                                @onNextPage="fnGoPage"
                                @onPrevPage="fnGoPage"
                                @onFirstPage="fnGoPage"
                                @onLastPage="fnGoPage"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <AdminDetail
        v-if="state.isShowAdmin"
        :idx="state.idx"
        @close="state.isShowAdmin = false"
        @callback="
            state.isShowAdmin = false;
            fnGetList(1);
        "
    ></AdminDetail>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        :gubun="state.gubun"
        @close="closeModal"
        @callback="callbackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        DataGrid,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        AdminDetail,
        PageBtn,
        CommonUtils,
        onActivated,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, DataGrid, AdminDetail },
        setup() {
            const global = globalStore();
            const user = userStore();

            const state = reactive({
                order: 0 as number,
                idx: 0 as number,
                isShowAdmin: false as boolean,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
                gubun: 1 as 1 | 2 | 3, // 1: update, 2: delete, 3: insert
            });

            const pageState = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    { key: "", label: "No.", class: "text-center" },
                    { key: "name", label: "이름", class: "text-center" },
                    { key: "id", label: "아이디", class: "text-center" },
                    { key: "auth", label: "권한", class: "text-center" },
                    { key: "auas", label: "담당", class: "text-center" },
                    { key: "team", label: "부서", class: "text-center" },
                    {
                        key: "createDate",
                        label: "등록일",
                        class: "text-center",
                        render: (row: any) => {
                            return CommonUtils.formatDate(row.createDate);
                        },
                    },
                    {
                        key: "lastLoginDate",
                        label: "마지막 접속 시간",
                        class: "text-center",
                        render: (row: any) => {
                            if (row.lastLoginDate !== null) return CommonUtils.formatDate(row.lastLoginDate);
                            return "";
                        },
                    },

                    {
                        key: "btnModal",
                        label: "수정",
                        class: "text-center",
                        clickable: true,
                        render: (row: any) => {
                            return "<button type = 'text'>수정</button>";
                        },
                    },

                    {
                        key: "btnRemove",
                        label: "삭제",
                        class: "text-center",
                        clickable: true,
                        render: (row: any) => {
                            return "<button type = 'text'>삭제</button>";
                        },
                    },
                ],
            });

            onActivated(() => {
                initState();
                fnGetList(pageState.currentPage);
            });

            const initState = () => {
                state.isShowAdmin = false;
                state.isShowModal = false;
                state.modalTab = -1;
                state.modalIsResult = false;
                state.modalTitle = "";
                state.modalContent = "";
                pageState.list = [];
                pageState.isLoading = false;
            };

            const fnGetList = async (page: number) => {
                pageState.currentPage = page;
                pageState.isLoading = true;
                const param: types.ReqParam = {
                    page: page,
                    size: pageState.perPage,
                    order: state.order,
                    startDate: null,
                    endDate: null,
                    searchType: "",
                    searchText: "",
                };
                let res: types.ResPaging = await apiService.admin.list(param);

                if (res.returnCode === 0 && res.list) {
                    pageState.list = res.list.data;
                    pageState.length = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                }
                pageState.isLoading = false;
            };

            const fnRowClick = (row: any, col: any) => {
                if (col.key === "btnModal") {
                    state.idx = row.idx;
                    state.isShowAdmin = true;
                } else if (col.key === "btnRemove") {
                    state.idx = row.idx;
                    confirmRemove();
                }
            };

            const fnGoPage = (page: number) => {
                pageState.currentPage = page;
            };

            const add = () => {
                state.idx = 0;
                state.isShowAdmin = true;
            };

            const confirmRemove = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 2;
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callbackModal = (param: any) => {
                if (param.action === "confirm") {
                    switch (param.gubun) {
                        case 2:
                            remove();
                            break;
                    }
                } else if (param.action === "callback") {
                    switch (param.gubun) {
                        case 2:
                            fnGetList(pageState.currentPage);
                            break;
                    }
                    state.isShowModal = false;
                    state.idx = 0;
                }
            };

            const remove = async () => {
                const res = await apiService.admin.remove(state.idx);
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제되었습니다.";
                    state.isShowModal = true;
                    state.gubun = 2;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            return {
                state,
                pageState,
                fnRowClick,
                fnGoPage,
                fnGetList,
                CommonUtils,
                add,
                closeModal,
                callbackModal,
            };
        },
    };
</script>
<style>
    .sch_list label:last-child {
        border-right: white;
    }
</style>
